import { useQuery } from '@tanstack/react-query'
import { apiGetSoftwares } from '~/api/adminApi'

export const useSoftwaresQuery = () => useQuery({
  queryKey: ['softwares'],
  queryFn: apiGetSoftwares,
  select: data => data.data,
  refetchOnWindowFocus: false
})
